import { UKFlagIcon, FranceFlagIcon, LogoutIcon } from "assets/icons";
import { useLanguage } from "hooks";
import { useClearManagerSession } from "modules/companyAdminAuth";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon } from "ui";

// Reuse admin LogoutModal styles to keep look identical.
import styles from "../../../common/components/LogoutModal/LogoutModal.module.scss";

const CompanyLogoutModal = () => {
  const clearSession = useClearManagerSession();
  const { switchLanguage, isEnglishActive } = useLanguage();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logout = async () => {
    await clearSession();
    navigate("/login", { replace: true });
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modal__wrapper}>
        <div
          className={styles.modal__wrapper__item}
          onClick={async (e) => {
            e.stopPropagation();
            await switchLanguage();
          }}
        >
          <Icon
            className={styles.modal__wrapper__item__icon}
            as={isEnglishActive ? UKFlagIcon : FranceFlagIcon}
            boxSize={20}
            color="#090914"
          />
          <p>{t("Language")}</p>
        </div>
        <div className={styles.modal__wrapper__item} onClick={logout}>
          <Icon
            className={styles.modal__wrapper__item__icon}
            as={LogoutIcon}
            boxSize={20}
            color="#090914"
          />
          <p>{t("Logout")}</p>
        </div>
      </div>
    </div>
  );
};

export default CompanyLogoutModal;
